import { LoadingState, NoFlyZoneState } from '../store.states';
import { NoFlyZone } from '../../models/geoasset.model';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  createNoFlyZoneAssets,
  creatingNoFlyZoneAssetsError,
  creatingNoFlyZoneAssetsSuccess,
  editNoFlyZone,
  editNoFlyZoneError,
  editNoFlyZoneSuccess,
  loadingNoFlyZoneAssets,
  loadingNoFlyZoneAssetsError,
  loadingNoFlyZoneAssetsSuccess,
} from './noflyzone.actions';

export const noFlyZonesAdapter = createEntityAdapter<NoFlyZone>({
  selectId: (nfz) => nfz.id,
  sortComparer: false,
});

export const initialState: NoFlyZoneState = {
  noFlyZones: noFlyZonesAdapter.getInitialState(),
  loadingState: LoadingState.FUTURE,
  updateState: LoadingState.FUTURE,
  error: null,
  completed: false,
};

export const noFlyZoneReducer = createReducer(
  initialState,
  on(loadingNoFlyZoneAssets, (state) => ({
    ...state,
    loadingState: LoadingState.PENDING,
    completed: false,
  })),

  on(loadingNoFlyZoneAssetsSuccess, (state, { noFlyZones }) => ({
    ...state,
    loadingState: LoadingState.SUCCESS,
    noFlyZones: noFlyZonesAdapter.setAll(noFlyZones, state.noFlyZones),
    completed: true,
  })),

  on(loadingNoFlyZoneAssetsError, (state, { error }) => ({
    ...state,
    loadingState: LoadingState.ERROR,
    error: error,
    completed: false,
  })),

  on(createNoFlyZoneAssets, (state) => ({
    ...state,
    loading: true,
    updateState: LoadingState.PENDING,
  })),

  on(creatingNoFlyZoneAssetsSuccess, (state, { noFlyZone }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.SUCCESS,
    noFlyZones: noFlyZonesAdapter.addOne(noFlyZone, state.noFlyZones),
    error: null,
  })),

  on(creatingNoFlyZoneAssetsError, (state, { error }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.ERROR,
    error,
  })),

  on(editNoFlyZone, (state) => ({
    ...state,
    loading: true,
    updateState: LoadingState.PENDING,
  })),

  on(editNoFlyZoneSuccess, (state, { noFlyZone }) => {
    console.log('Reducer handling editNoFlyZoneSuccess, updating state');
    return {
      ...state,
      loading: false,
      updateState: LoadingState.SUCCESS,
      loadingState: LoadingState.SUCCESS,
      noFlyZones: noFlyZonesAdapter.upsertOne(noFlyZone, state.noFlyZones),
      error: null,
    };
  }),

  on(editNoFlyZoneError, (state, { error }) => ({
    ...state,
    loading: false,
    updateState: LoadingState.ERROR,
    error: error,
  })),
);
